import { render, staticRenderFns } from "./BookAddressMap.vue?vue&type=template&id=41160879&scoped=true"
import script from "./BookAddressMap.vue?vue&type=script&lang=js"
export * from "./BookAddressMap.vue?vue&type=script&lang=js"
import style0 from "./BookAddressMap.vue?vue&type=style&index=0&id=41160879&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41160879",
  null
  
)

export default component.exports